/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
// @ts-ignore
import Chart from "react-apexcharts";
// @ts-ignore
import { ApexOptions } from "apexcharts";

import styles from "./DistrubutionChart.module.scss";

const DistrubutionChart = ({ title, description, data }: any) => {
  const [barChartOptions, setBarChartOptions] = useState<ApexOptions>({
    chart: {
      type: "bar",
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: false,
        barHeight: "42px"
      }
    },
    stroke: {
      colors: ["#fff"],
      width: 0
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#000000"]
      }
    },
    xaxis: {
      categories: [],
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "16px",
          fontWeight: 600
        }
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    grid: {
      show: false
    },
    legend: {
      show: true,
      position: "bottom",
      fontSize: "16px",
      fontWeight: 400,
      markers: {
        size: 16, // to be checked
        // width: 16,
        // height: 16,
        // radius: 5
      },
      itemMargin: {
        horizontal: 10
      },
      height: 50
    },

    colors: ["#FFC759", "#00C29B", "#BF0D9F", "#8338EB"],
    series: []
  });

  useEffect(() => {
    if (data && data.length) {
      // "Lower", "Lower Middle", "Upper Middle", "Upper"
      const _categories: string[] = [];
      const _series: any = [
        {
          name: "Female",
          data: []
        },
        {
          name: "Male",
          data: []
        },
        {
          name: "Transgender",
          data: []
        },
        {
          name: "Nonbinary",
          data: []
        }
      ];

      data.map((_data: any) => {
        _categories.push(_data.quarters);
        if (_data.femalePercentage) {
          _series[0].data.push(_data.femalePercentage);
        }
        if (_data.malePercentage) {
          _series[1].data.push(_data.malePercentage);
        }
      });

      setBarChartOptions({
        ...barChartOptions,
        xaxis: {
          ...barChartOptions.xaxis,
          categories: _categories
        },
        series: _series
      });
    }
  }, [data]);

  return (
    <>
      <div className={styles.chartFullWrappers}>
        <div className={styles.chartWrapper}>
          <div className={styles.chartTitle}>{title}</div>
          <Chart
            options={barChartOptions}
            series={barChartOptions.series}
            type="bar"
            height={300}
          />
        </div>
        <div className={styles.chartInsightWrapper}>
          <div className={styles.chartInsight}>
            <div className={styles.insightTitle}>Insight</div>
            <div className={styles.chartDescription}>{description}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DistrubutionChart;
